import { Button, Tooltip } from '@bedrock/components';
import { CompressSquare, ExpandSquare } from '@bedrock/icons-react';
import { useFullscreen } from 'ahooks';
import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames/bind';
import styles from './index.less';

const cx = classNames.bind(styles);

interface Props {
  fullRef: React.RefObject<HTMLDivElement>;
  handleFullChange?: (isFullscreen) => void;
}

export const FullScreenButton = forwardRef(({
  fullRef,
  handleFullChange
}: Props, ref) => {
  const [isFullscreen, { toggleFullscreen }] = useFullscreen(
    fullRef,
    { pageFullscreen: { zIndex: 1000 } }
  );

  const handleExpandScreen = (e?: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e?.preventDefault();
    e?.stopPropagation();
    toggleFullscreen();
    handleFullChange?.(!isFullscreen);
    if (!isFullscreen) {
      fullRef?.current?.classList?.add(cx('fullscreen'));
    } else {
      fullRef?.current?.classList?.remove(cx('fullscreen'));
    }
  }

  useImperativeHandle(ref, () => ({
    handleExpandScreen,
  }))

  return (
    <Tooltip
      title={isFullscreen ? '退出全屏' : "全屏"}
      key={isFullscreen ? 'full' : 'notFull'}
    >
      <Button
        onClick={handleExpandScreen}
        type="text-subtle"
        icon={isFullscreen ? <CompressSquare /> : <ExpandSquare />}
      />
    </Tooltip>
  )
})
